export enum ItemType {
  TELA = 'TELA',
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  COPIAR = 'COPIAR',
  NONE = 'NONE',
  SITEF_CREDIT_CARD = 'pinpadCreditCard',
  SITEF_DEBIT_CARD = 'pinpadDebitCard',
}
